import { useSelector, useDispatch } from "react-redux";

import { Button } from 'semantic-ui-react'

import { gameActions } from "../store/game-slice";

function Welcome() {
  const dispatch = useDispatch();

  function btnGetStartedClickHandler(e) {
    dispatch(gameActions.setScreen("choose_theme"));
  }

  return (
    <section className="welcome">
      <header className="logo-header">
      <img src="images/ezpass.svg" className="ez-logo"></img>
      <img src="images/bingo.svg" className="bingo-logo"></img>
      <p>
      Shift into high gear for this game, as it&apos;s all about speed. Each round you play, try to beat your best time. Ready, set, binGO!
      </p>
      </header>
      <div className="welcome-text">
        <p>
          Ways to Win<br />
          <img src="images/ways-to-win.svg"></img>
        </p>
        <p>
          <Button onClick={btnGetStartedClickHandler}>
            Let's Get Started
          </Button>
        </p>
      </div>
    </section>
  );
}

export default Welcome;
